import { handleize } from '../helpers';
import sendQuery from './send-query';

const findBackVariantImage = (gql_product, variant_id) => {
  const variant_index = _.findIndex(gql_product.variants.edges, { node: { id: variant_id } });
  const variant = gql_product.variants.edges[variant_index].node;
  const color_value = _.find(variant.selectedOptions, { name: 'Color' }).value || '';
  const color_handle = handleize(color_value);
  // const variant_front_image = variant.image.url;
  let variant_back_image = '';

  // Find the next variant with a different color
  let found_same_color = false;
  for (let i = 0; i < gql_product.variants.edges.length; i++) {
    const find_variant = gql_product.variants.edges[i].node;
    const find_color_value = _.find(find_variant.selectedOptions, { name: 'Color' }).value || '';
    const find_color_handle = handleize(find_color_value);

    if (find_color_handle === color_handle) {
      found_same_color = true;
      continue;
    } else if (found_same_color && variant_back_image === '') {
      const next_variant_with_different_color = gql_product.variants.edges[i].node;
      const next_front_image = next_variant_with_different_color.image.url;
      const next_front_image_index = _.findIndex(gql_product.images.edges, { node: { url: next_front_image }});

      if (typeof gql_product.images.edges[next_front_image_index - 1] !== 'undefined') {
        variant_back_image = gql_product.images.edges[next_front_image_index - 1].node.url;
      }
      
      found_same_color = false;
      break;
    }
  }

  // console.log(variant_front_image, variant_back_image);

  // Last color variant
  if (found_same_color && variant_back_image === '') {
    variant_back_image = _.last(gql_product.images.edges).node.url;
  }

  return variant_back_image;
};

const swatchesHtml = (gql_product) => {
  let swatches = '';

  // Only 1 per color
  const colors = [];
  gql_product.variants.edges.forEach(gql_variant => {
    const color_value = _.find(gql_variant.node.selectedOptions, { name: 'Color' }).value || '';
    const color_handle = handleize(color_value);

    if (!colors.includes(color_handle)) {
      colors.push(color_handle);

      // Extract back image
      let front_image_url = '';
      let back_image_url = '';
      if (typeof gql_variant.node.image !== 'undefined' && gql_variant.node.image !== null) {
        front_image_url = gql_variant.node.image.url;
        back_image_url = findBackVariantImage(gql_product, gql_variant.node.id);
      }

      swatches += `<div data-color-swatch class="color-swatch" role="img" tabindex="0" data-variant-id="${_.last(gql_variant.node.id.split('/'))}" data-color-value="${color_value}" data-color-handle="${color_handle}" data-front="${front_image_url}" data-back="${back_image_url}"><span></span></div>`;
    }
  });

  return swatches;
};

const prettyfyProductsByID = (gql_products) => {
  const products = [];

  gql_products.forEach(gql_product => {
    const formatted_variants = [];
    gql_product.node.variants.edges.forEach(gql_variant => {
      // console.log('variant id', Number(_.last(gql_variant.node.id.split('/'))));

      const variant_color = _.find(gql_variant.node.selectedOptions, { name: 'Color' });
      const variant_size = _.find(gql_variant.node.selectedOptions, { name: 'Size' });

      if (typeof variant_color !== 'undefined' && typeof variant_size !== 'undefined') {
        if (typeof gql_variant.node.image === 'undefined' || gql_variant.node.image === null) {
          console.log('Variant has missing image: ', gql_variant);
        }
        formatted_variants.push({
          id: Number(_.last(gql_variant.node.id.split('/'))),
          title: gql_variant.node.title || '',
          image: (typeof gql_variant.node.image === 'undefined' || gql_variant.node.image === null) ? '' : gql_variant.node.image.url || '',
          image_alt: (typeof gql_variant.node.image === 'undefined' || gql_variant.node.image === null) ? '' : gql_variant.node.image.altText || '',
          price: String(parseFloat(gql_variant.node.price.amount) * 100),
          compare_at_price: (gql_variant.node.compareAtPrice === null) ? '0' : String(parseFloat(gql_variant.node.compareAtPrice.amount) * 100) || '0',
          available: gql_variant.node.availableForSale,
          inventory_quantity: gql_variant.node.quantityAvailable,
          color: variant_color.value || '',
          size: variant_size.value || '', 
          online_inventory: (typeof gql_variant.node.astrOnlineInventory === 'undefined' || gql_variant.node.astrOnlineInventory === null) ? null : Number(gql_variant.node.astrOnlineInventory.value) || null,
          online_inventory_style: (typeof gql_variant.node.astrOnlineInventoryStyle === 'undefined' || gql_variant.node.astrOnlineInventoryStyle === null) ? null : Number(gql_variant.node.astrOnlineInventoryStyle.value) || null,
          style_flag_standard: (typeof gql_variant.node.astrStyleFlagStandard === 'undefined' || gql_variant.node.astrStyleFlagStandard === null) ? null : gql_variant.node.astrStyleFlagStandard.value || null,
          style_flag_plus: (typeof gql_variant.node.astrStyleFlagPlus === 'undefined' || gql_variant.node.astrStyleFlagPlus === null) ? null : gql_variant.node.astrStyleFlagPlus.value || null,
        });
      } else {
        console.log('Cannot find color or size for variant', gql_variant.node);
      }
    });

    const store_domain = window.Shopify.shop.includes('staging') ? `https://${window.Shopify.shop}` : 'https://www.astrthelabel.com';

    if (formatted_variants.length > 0) {
      const product_obj = {
        id: Number(_.last(gql_product.node.id.split('/'))),
        handle: gql_product.node.handle,
        available: gql_product.node.availableForSale,
        title: gql_product.node.title || '',
        url: (gql_product.node.onlineStoreUrl === null) ? `/products/${gql_product.node.handle}` : gql_product.node.onlineStoreUrl.replace(store_domain, '') || '', // password protected store will return null for this field
        type: gql_product.node.productType || '',
        from: (gql_product.node.priceRange.maxVariantPrice.amount !== gql_product.node.priceRange.minVariantPrice.amount) ? String(parseFloat(gql_product.node.priceRange.minVariantPrice.amount) * 100) : '',
        compare_at_price: (gql_product.node.compareAtPriceRange === null) ? '0' : (gql_product.node.compareAtPriceRange.maxVariantPrice !== null && gql_product.node.compareAtPriceRange.maxVariantPrice.amount !== '0.0') ? String(parseFloat(gql_product.node.compareAtPriceRange.maxVariantPrice.amount) * 100) : '0',
        swatches: swatchesHtml(gql_product.node),
        swatches_raw: (typeof gql_product.node.astrSwatches === 'undefined' || gql_product.node.astrSwatches === null) ? null : gql_product.node.astrSwatches.value || null,
        variants: formatted_variants,
        images: gql_product.node.images.edges.map(item => item.node.url) || [],
        images_raw: (typeof gql_product.node.astrImagesDetails === 'undefined' || gql_product.node.astrImagesDetails === null) ? null : gql_product.node.astrImagesDetails.value || null,
        stamped_average: (typeof gql_product.node.stampedAverage === 'undefined' || gql_product.node.stampedAverage === null) ? null : gql_product.node.stampedAverage.value || null,
        bestseller_14: (typeof gql_product.node.astrBestseller14 === 'undefined' || gql_product.node.astrBestseller14 === null) ? null : gql_product.node.astrBestseller14.value || null,
        bestseller_30: (typeof gql_product.node.astrBestseller30 === 'undefined' || gql_product.node.astrBestseller30 === null) ? null : gql_product.node.astrBestseller30.value || null,
      };

      if (typeof gql_product.node.tags !== 'undefined' && gql_product.node.tags !== null) {
        product_obj.tags = gql_product.node.tags;
      }

      if (typeof gql_product.node.collections !== 'undefined' && gql_product.node.collections !== null) {
        product_obj.collections = (gql_product.node.collections.edges).map(item => item.node.handle);
      }

      products.push(product_obj);
    } else {
      console.log('The following product has no variants attached due to wrong attributes', gql_product.node);
    }
  });

  return products;
};

// Products with the most variants and images: https://astr-the-label.myshopify.com/admin/products/4416918650950
// product_ids: Array of product IDs
// return_raw: Boolean. Returns either the prettyfied version or the raw version of the API data
export default async (
  product_ids,
  return_raw = false,
  get_description = false,
  get_metafields = false,
  get_inventory = false,
  get_collections = false,
  get_tags = false,
  get_metafields_for_tiles = false,
  ) => {
  try {
    if (!product_ids.length) {
      return [];
    }

    // Don't forget to expose the metafield to the storefront API first using an external GraphQL query
    let product_metafields_query = '';
    let variant_metafields_query = '';
    if (get_metafields) {
      product_metafields_query += `
        stampedBadge: metafield(namespace: "stamped", key: "badge") {
          value
        }
        stampedAverage: metafield(namespace: "stamped", key: "reviews_average") {
          value
        }
        astrBestseller14: metafield(namespace: "astr", key: "bestseller_style_14") {
         value
        }
        astrBestseller30: metafield(namespace: "astr", key: "bestseller_style_30") {
         value
        }
        astrSwatches: metafield(namespace: "astr", key: "swatches") {
         value
        }
        astrImagesDetails: metafield(namespace: "astr", key: "images_details") {
         value
        }
        astrSizefitHeight: metafield(namespace: "astr", key: "sizefit_height") {
          value
        }
        astrSizefitHip: metafield(namespace: "astr", key: "sizefit_hip") {
          value
        }
        astrSizefitWaist: metafield(namespace: "astr", key: "sizefit_waist") {
          value
        }
        astrSizefitBust: metafield(namespace: "astr", key: "sizefit_bust") {
          value
        }
        astrSizefitFit: metafield(namespace: "astr", key: "sizefit_fit") {
          value
        }
        astrSizefitLength: metafield(namespace: "astr", key: "sizefit_length") {
          value
        }
        astrSizefitSize: metafield(namespace: "astr", key: "sizefit_size") {
          value
        }
        astrSizefitInseam: metafield(namespace: "astr", key: "sizefit_inseam") {
          value
        }
        astrDetailcareWashingInstructions: metafield(namespace: "astr", key: "detailcare_washing_instructions") {
          value
        }
        astrDetailcareFabricContent: metafield(namespace: "astr", key: "detailcare_fabric_content") {
          value
        }
        astrDetailcareAttribute1: metafield(namespace: "astr", key: "detailcare_attribute_1") {
          value
        }
        astrDetailcareAttribute2: metafield(namespace: "astr", key: "detailcare_attribute_2") {
          value
        }
        astrDetailcareAttribute3: metafield(namespace: "astr", key: "detailcare_attribute_3") {
          value
        }
        astrDetailcareStyleNumber: metafield(namespace: "astr", key: "detailcare_style_number") {
          value
        }
      `;

      variant_metafields_query = `
        astrStyleDescription: metafield(namespace: "astr", key: "style_description") {
          value
        }
        astrStyleSizefitHeight: metafield(namespace: "astr", key: "style_model_height") {
          value
        }
        astrStyleSizefitSize: metafield(namespace: "astr", key: "style_model_size") {
          value
        }
        astrStyleSizefitHip: metafield(namespace: "astr", key: "style_model_hips") {
          value
        }
        astrStyleSizefitWaist: metafield(namespace: "astr", key: "style_model_waist") {
          value
        }
        astrStyleSizefitBust: metafield(namespace: "astr", key: "style_model_bust") {
          value
        }
        astrStyleSizefitFit: metafield(namespace: "astr", key: "style_sizefit_fits") {
          value
        }
        astrStyleSizefitLength: metafield(namespace: "astr", key: "style_sizefit_length") {
          value
        }
        astrStyleSizefitInseam: metafield(namespace: "astr", key: "style_sizefit_inseam") {
          value
        }
      `;
    }

    if (get_metafields_for_tiles) {
      variant_metafields_query += `
        astrStyleFlagStandard: metafield(namespace: "astr", key: "style_flag") {
          value
        }
        astrStyleFlagPlus: metafield(namespace: "astr", key: "style_flag_plus_sizes") {
          value
        }
      `;
    }

    if (get_inventory) {
      variant_metafields_query += `
        astrOnlineInventory: metafield(namespace: "astr", key: "online_inventory") {
          value
        }
        astrOnlineInventoryStyle: metafield(namespace: "astr", key: "online_inventory_style") {
          value
        }
      `;
    }

    let description_fields = '';
    if (get_description) {
      description_fields = `description
      descriptionHtml`;
    }

    // Already in Nosto but we still need it for the quickview in order to load the promo message correctly
    let collections_fields = '';
    if (get_collections) {
      collections_fields = `collections(first: 20) {
        edges {
          node {
            handle
          }
        }
      }`;
    }

    // Already in Nosto
    let collections_tags = '';
    if (get_tags) {
      collections_tags = 'tags';
    }

    const query = `
      query getProductsByID {
        products(first: ${product_ids.length}, query: "id:${product_ids.join(' OR id:')}") {
          edges {
            node {
              id
              handle
              availableForSale
              title
              ${description_fields}
              ${collections_fields}
              ${collections_tags}
              onlineStoreUrl
              productType
              images(first: 100) {
                edges {
                  node {
                    url
                    altText
                  }
                }
              }
              ${product_metafields_query}
              priceRange {
                maxVariantPrice {
                  amount
                }
                minVariantPrice {
                  amount
                }
              }
              compareAtPriceRange {
                maxVariantPrice {
                  amount
                }
              }
              variants(first: 100) {
                edges {
                  cursor
                  node {
                    id
                    title
                    availableForSale
                    quantityAvailable
                    image {
                      url
                      altText
                    }
                    price {
                      amount
                    }
                    compareAtPrice {
                      amount
                    }
                    selectedOptions {
                      name
                      value
                    }
                    ${variant_metafields_query}
                  }
                }
              }
            }
          }
        }
      }
    `;

    // console.log('query', query);

    const response = await sendQuery(query);

    if (!response.ok) {
      // throw new Error(`HTTP error ${response.status}`);
      console.log(`HTTP error ${response.status}`);
      return [];
    }

    const response_json = await response.json();
    // console.log('response_json', response_json)

    if (typeof response_json.errors !== 'undefined') {
      console.log('[Storefront API] Error in response:', response_json.errors);
      return [];
    }

    if (typeof response_json.data === 'undefined') {
      console.log('[Storefront API] No data', response_json);
      return [];
    }

    const original_data = _.cloneDeep(response_json.data.products.edges);
    // console.log('Storefront API data (raw)', original_data);

    if (return_raw === true) {
      return original_data;
    }

    // console.log('Load products by ID', response_json);
    const formatted_data = prettyfyProductsByID(response_json.data.products.edges);
    console.log('Storefront API data (prettyfied)', formatted_data);

    return formatted_data;
  } catch (error) {
    console.log('[Storefront API]', error);
    return [];
  }
};
